import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetBagsCashReportReqData } from "./GetBagsCashReportReqData";
import { GetBagsCashReportResData } from "./GetBagsCashReportResData";

const ENDPOINT = "/cash_flow/bags_cash_report";

export class GetBagsCashReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: GetBagsCashReportReqData = null;

    constructor(reqData: GetBagsCashReportReqData) {
        super();
        this.params = reqData;
    }

    public async execute(): Promise<GetBagsCashReportResData> {
        var res = await this.executeCommand(this.params);
        return new GetBagsCashReportResData(res);
    }
}
